import jQuery from "jquery";
import qs from "qs";

const handle = {
    inArrayRole(key, rootState) {
        let role = rootState.$roles;
        let len = role.length;
        let status = false;
        for (let i = 0; i < len; i++) {
            if (role[i] === key) {
                status = true;
            }
        }
        return status;
    }
};

const mutations = {
    /**当前页面**/
    CHANGE_PAGE(state, page) {
        state.$page = page;
    },

    /**启用loading**/
    LOADING(state, args) {
        state.$loading = args;
    },

    /**
     * 无权限访问页面处理
     * @constructor
     */
    NO_ACCESS_PAGE(
        state,
        { commit, dispatch, rootState, args, status, selectPlaceholder }
    ) {
        state.$isaccess = status;
        // state.$activeGameCode = '';
        //state.$activeGameInfo = [];
        state.$selectDisabledStatus = !state.$gameList.length;
        state.$selectPlaceholder =
            selectPlaceholder !== undefined
                ? selectPlaceholder
                : state.$selectDisabledStatus
                ? "用户无游戏权限"
                : state.$selectPlaceholder;
    },

    /**内容区域LOADING**/
    PRIVATE_LOADING(state, args) {
        jQuery(window).resize(() => {
            let breadcrumb = jQuery("#page-main-breadcrumb");
            let content = jQuery("#page-main-content");
            let loading = jQuery("#loading-private");
            let window_height =
                jQuery(window).height() - jQuery(".el-header").outerHeight();
            let height = breadcrumb.height() + content.outerHeight();
            if (height < window_height) {
                height = window_height;
            }
            loading.height(height);
        });

        if (args) {
            let timeout = () => {
                setTimeout(() => {
                    let breadcrumb = jQuery("#page-main-breadcrumb");
                    let content = jQuery("#page-main-content");
                    let loading = jQuery("#loading-private");
                    let window_height =
                        jQuery(window).height() -
                        jQuery(".el-header").outerHeight();
                    //console.log(window_height);
                    if (breadcrumb.length === 0) {
                        timeout();
                    } else {
                        //console.log(breadcrumb.height() + content.outerHeight());
                        let height =
                            breadcrumb.height() + content.outerHeight();
                        //console.log(window_height, height);
                        if (height < window_height) {
                            height = window_height;
                        }
                        loading.height(height);
                        state.$loadingPrivate = args;
                    }
                }, 50);
            };
            timeout();
        } else {
            state.$loadingPrivate = args;
        }
    },

    /***
     * 设置内容区域高度
     * @constructor
     */
    SET_CONTENT_HEIGHT(state, height) {
        state.$iframeHeight = height;
    },
    _updateJumpProjectType(state, args) {
        state.$jumpProjectTypeRoute1 = args.projectTypeRoute1;
        state.$jumpProjectTypeRoute2 = args.projectTypeRoute2;
        //console.log(state.$jumpProjectTypeRoute1, state.$jumpProjectTypeRoute2)
    },

    _updateLoading(state, args) {
        state.$loading = args;
    },

    _updateAccessStatus(state, status) {
        state.$isaccess = status;
    },

    _updateActiveGameInfo(state, args) {
        state.$activeGameInfo = Object.assign({}, args.gameinfo);
        if (args.type) {
            args.rootState.$helper.localStorage.remove("odp_gameList");
        }
    },

    updateAppInfo(state, res) {
        state.$gameList = res["gamelist"]["data"]["games"];
        state.$userInfo = res["gamelist"]["data"]["user"];
        state.$gameAdminList = res["gamelist"]["data"]["games_admin"];
    },

    updateUserRoles(state, args) {
        let token = args.rootState.$helper.cookie.get(
            args.rootState.$config.userLoginAccessTokenKey
        );
        let user = JSON.parse(
            args.rootState.$base64.decode(token.split(".")[1])
        );

        if(Array.isArray(user["params"]["roles"])){
            user["params"]["roles"] = user["params"]["roles"].map(item => item.replace('ODP5PANELCHINA', 'ODP5'))
        }
        state.$roles = user["params"]["roles"];

        /**设置管理**/
        if (handle.inArrayRole("ROLE_APP_ODP5_SYS_ADMIN", args.rootState)) {
            state.$isAdmin = 1;
        }
    },

    updateAppGameCode(state, code) {
        if (!code) {
            code = state.$helper.helper.getParamers("game_code");
        }
        let codes = state.$gameList.map(v => v.game_code);
        /**用户第一次进浏览器没有选择游戏code，使用用户返回游戏的第一个游戏**/
        if (!code) {
            state.$activeGameCode = codes[0];
        } else if (codes.indexOf(code) === -1) {
            state.$activeGameCode = codes[0];
        } else {
            state.$activeGameCode = code;
        }
        let urlParams = state.$helper.helper.getUrlParams();
        urlParams = Object.assign({}, urlParams, {
            game_code: state.$activeGameCode
        });

        window.history.pushState(null, null, "?" + qs.stringify(urlParams));
        if (state.$gameAdminList.indexOf(state.$activeGameCode) >= 0) {
            state.$isGameAdmin = 1;
        } else {
            state.$isGameAdmin = 0;
        }
    },

    updateProjectType(state, type) {
        // let type = state.$helper.cookie.get('odp-projectType');
        // if (!type) {
        //     type = state.$jumpProjectTypeRoute1 ? 1 : 2;
        // }
        state.$projectType = parseInt(type);
    },

    _updateMune(state, mune) {
        state.$routerMaps = mune;
    },

    _updateSaveVueObject(state, $vue) {
        state.$vue = $vue;
    },

    _setTitle(state, pageName) {
        state.$title = state.$s_title + ` - ${pageName}`;
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./website/store/mutations.js